import axios from 'axios'

export default {
	state: {
		api: {
			address: 'https://carlosdevpereira.dynip.sapo.pt:8080',
		},

		locale: (() => {
			let savedLocale = localStorage.getItem('locale')
			if (!savedLocale) return navigator.language.split('-')[0]

			return savedLocale
		})(),

		youtube: {
			video: 'https://www.youtube.com/embed/sdOc2l9mSEc',
			channel: 'https://www.youtube.com/channel/UCiuVBg1d5-_YwEWJGN-uGlw',
		},

		socialProfiles: {
			instagram: 'https://www.instagram.com/carlosdevpereira/',
			linkedin: 'https://www.linkedin.com/in/carlosdevpereira/',
			github: 'https://github.com/carlosdevpereira',
		},

		testimonials: [],
		isLoadingTestimonials: false,
	},

	mutations: {
		SET_LOCALE: (state, { i18n, locale }) => {
			state.locale = locale
			i18n.locale = locale
			localStorage.setItem('locale', locale)
		},

		TOGGLE_LOCALE: (state, i18n) => {
			let newLocale = null
			if (i18n.locale === 'en') newLocale = 'pt'
			else newLocale = 'en'

			state.locale = newLocale
			i18n.locale = newLocale
			localStorage.setItem('locale', newLocale)
		},

		SET_IS_LOADING_TESTIMONIALS: (state, isLoading = true) =>
			(state.isLoadingTestimonials = isLoading),

		SET_TESTIMONIALS_LIST: (state, testimonials) =>
			(state.testimonials = testimonials),
	},

	actions: {
		// === Testimonials ===
		requestTestimonials: ({ state, commit }) => {
			return new Promise((resolve, reject) => {
				if (state.isLoadingTestimonials) return reject(409)
				commit('SET_IS_LOADING_TESTIMONIALS')

				return axios
					.get(`${state.api.address}/testimonials`)
					.then(response => {
						commit('SET_TESTIMONIALS_LIST', response.data.data)
						commit('SET_IS_LOADING_TESTIMONIALS', false)
						resolve(response.data)
					})
					.catch(() => {
						commit('SET_IS_LOADING_TESTIMONIALS', false)
					})
			})
		},

		// === Mailer ===
		sendEmail: ({ state }, payload) => {
			return new Promise((resolve, reject) => {
				return axios
					.post(`${state.api.address}/mailer/send`, payload)
					.then(response => resolve(response.data))
					.catch(err => reject(err))
			})
		},
	},
}
